import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { keyBy } from "lodash-es";

import { useConnections } from "src/api/connectApi/queries";
import { ProviderIcon } from "src/connections/config/Icon";
import { NodeIcon } from "src/design-system/NodeIcon";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const ConnectionIcon: React.FC<{
  connectionId: string | undefined;
  size?: "sm" | "md";
  fallbackIcon: IconProp;
}> = ({ connectionId, size, fallbackIcon }) => {
  const { workspace } = useWorkspaceContext();
  const connections = useConnections(workspace.base_url);

  const connectionsById = keyBy(connections.data ?? [], "id");

  if (connectionId && connectionsById[connectionId]) {
    const connection = connectionsById[connectionId];

    return <ProviderIcon provider={connection.provider} size={size} />;
  }

  return <NodeIcon icon={fallbackIcon} color="outlined" size={size} />;
};
